/**
 * @version: v 1.0.0
 * @Author: zengying
 * @Date: 2022/10/8 17:43
 * @FileName: internationalRemittance.js
 * @LastEditor: 2022/10/8 17:43
 * @Name: internationalRemittance
 */

const internationalRemittance = {
  routes: [
    {
      path: '/internationalRemittance',
      name: 'internationalRemittance',
      meta: {
        title: '树'
      },
      component: () => import('@/project/views/international-remittance/international-remittance.vue')
    }
  ]
};
export default internationalRemittance;



// WEBPACK FOOTER //
// ./src/project/router/internationalRemittance.js